export default [
  {
    path: '/access-history',
    name: 'accessHistory',
    component: () => import('@/views/accessHistory/AccessHistoryList.vue'),
    meta: {},
  },
];
